export default __webpack_public_path__ + "static/media/peercoin-white.1dfb806b.png";